let currentStorageUserScopeId: string | undefined;

export const ANONYMOUS_TRAINING_USER_SCOPE_ID = 'training-anonymous-user';

type ResolveTrainingStorageScopeIdParams = {
  accountUserId?: string | null;
  connectionUserId?: string | null;
};

const normalizeScopeId = (value?: string | null): string | undefined => {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

export const resolveTrainingStorageScopeId = (
  params: ResolveTrainingStorageScopeIdParams,
): string => {
  return (
    normalizeScopeId(params.accountUserId) ??
    normalizeScopeId(params.connectionUserId) ??
    ANONYMOUS_TRAINING_USER_SCOPE_ID
  );
};

export const setCurrentStorageUserScopeId = (userScopeId: string | undefined): void => {
  currentStorageUserScopeId = userScopeId && userScopeId.length > 0 ? userScopeId : undefined;
};

export const getCurrentStorageUserScopeId = (): string | undefined => {
  return currentStorageUserScopeId;
};
